// extracted by mini-css-extract-plugin
export default {"wrapper":"LanguageTitle_wrapper__eIflQ"};